import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

export const policyqaApi = createApi({
  reducerPath: "policyqaApi",
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [""],
});
